var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SModalCentered", {
    attrs: {
      title: _vm.$t("stemdoerDetail.competenciesModal.title"),
      isOpen: _vm.isOpen,
      closeModal: _vm.closeModal,
      customProps: { bodyPaddingY: 0, fullWidthFooter: true },
      persistent: true,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "d-flex flex-column" },
              [
                _c("span", {
                  staticClass: "text-body-1 text--text text--base mb-4",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("stemdoerDetail.competenciesModal.subtitle")
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-6" },
                  [
                    _c("SSelectorMultiple", {
                      attrs: {
                        items: _vm.competenciesItems,
                        placeholder: _vm.$t(
                          "stemdoerDetail.competenciesModal.competenciesPlaceholder"
                        ),
                      },
                      model: {
                        value: _vm.selectedTechnologies,
                        callback: function ($$v) {
                          _vm.selectedTechnologies = $$v
                        },
                        expression: "selectedTechnologies",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.compsForm, function (comp, index) {
                  return _c(
                    "div",
                    {
                      key: comp.idTechnology,
                      staticClass:
                        "d-flex align-items-center justify-content-between mb-4",
                      staticStyle: { gap: "16px" },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            "content-class": "background-darken3 tooltip-top",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "text-body-2-bold text--text text--lighten-1 d-flex align-items-center fixed-width-span",
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.getTechnologyName(
                                                comp.idTechnology
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 d-flex align-items-center",
                                          },
                                          _vm._l(
                                            _vm.getStars(comp.score),
                                            function (star) {
                                              return _c("img", {
                                                key: star,
                                                attrs: {
                                                  src: "/content/svgs/star/star-fill-grey.svg",
                                                  width: "18",
                                                  height: "18",
                                                  alt: "star",
                                                },
                                              })
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center pt-1" },
                              [
                                _c("strong", { staticClass: "pr-1" }, [
                                  _vm._v(_vm._s(_vm.getTitleBadge(comp.score))),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.getStars(comp.score),
                                  function (tier) {
                                    return _c(
                                      "span",
                                      { key: tier },
                                      [
                                        _c("v-img", {
                                          attrs: {
                                            width: 20,
                                            src: "/content/svgs/star/star-fill-white.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-body-3" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getInfoBadge(
                                    comp.score,
                                    comp.idTechnology
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("SSelector", {
                        staticClass: "fixed-width-selector",
                        attrs: {
                          items: _vm.scoreOptions,
                          placeholder: _vm.compsForm[index].score.toString(),
                          onChange: (newValue) =>
                            _vm.updateScore(index, newValue),
                        },
                        model: {
                          value: _vm.compsForm[index].score,
                          callback: function ($$v) {
                            _vm.$set(_vm.compsForm[index], "score", $$v)
                          },
                          expression: "compsForm[index].score",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "ml-2 delete-trash",
                        on: {
                          click: function ($event) {
                            return _vm.removeComp(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0" },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "mr-6" },
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.closeModal,
                            btnStyle: "tertiary",
                            sText: _vm.$t(
                              "stemdoerDetail.competenciesModal.cancelButton"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.onSaveClick,
                            btnStyle: "primary",
                            sText: _vm.$t(
                              "stemdoerDetail.competenciesModal.saveButton"
                            ),
                            disabled: _vm.compsForm.length === 0,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }